import React, { ReactNode } from 'react';
import { Paper, SxProps } from '@mui/material';
import { CardVariant } from 'types';

type CardProps = {
  variant?: CardVariant;
  children: ReactNode;
  sx?: SxProps;
};

export const Card = ({ children, variant = 'secondary', sx }: CardProps) => {
  const color = {
    primary: {
      backgroundColor: 'rose.50',
      borderColor: 'rose.200',
    },
    secondary: {
      backgroundColor: 'grey.50',
      borderColor: 'grey.100',
    },
    success: {
      backgroundColor: 'success.light',
      borderColor: 'success.main',
    },
  };

  const { backgroundColor, borderColor } = color[variant];

  return <Paper sx={{ p: 5, backgroundColor, border: 1, borderColor, ...sx }}>{children}</Paper>;
};
